import { TopProducts } from './types'

export const articleTypes = {
  new: 'new_article',
  special: 'special_article'
} as const

export const displayMethods = {
  self: '_self',
  blank: '_blank'
} as const

export const TOP_SECTION_PRODUCTS: TopProducts[] = [
  {
    sectionTitle: '人気商品',
    productItems: [
      {
        id: 72,
        productImage: 'https://cdn-novelty.raksul.com/public_images/311f0c48-6413-4da3-a99f-f15ecf61d64e',
        minProductPrice: 85,
        maxProductPrice: 1784,
        quantityUnit: '枚',
        minProductQuantity:10,
        maxProductQuantity: 5000,
        displayName: '不織布フラットオリジナルトートバッグ',
        printTag: 'オリジナル印刷OK'
      },{
        id: 210,
        productImage: 'https://cdn-novelty.raksul.com/public_images/775a8cc9-d105-4139-a364-bf39dadf698b',
        minProductPrice: 707,
        maxProductPrice: 6077,
        quantityUnit: '枚',
        minProductQuantity:1,
        maxProductQuantity: 1000,
        displayName: '5.6オンス ハイクオリティーオリジナルTシャツ',
        printTag: 'オリジナル印刷OK'
      },{
        id: 143,
        productImage: 'https://cdn-novelty.raksul.com/public_images/97e0c039-2a72-4b67-8414-20ffcdc297e9',
        minProductPrice: 98,
        maxProductPrice: 181,
        quantityUnit: '枚',
        minProductQuantity:1,
        maxProductQuantity: 10000,
        displayName: '名入れタオル 薄手（200匁）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 534,
        productImage: 'https://cdn-novelty.raksul.com/public_images/46b48259-bacb-4a41-a558-5c1368c51fb3',
        minProductPrice: 543,
        maxProductPrice: 1100,
        quantityUnit: '枚',
        minProductQuantity:10,
        maxProductQuantity: 10000,
        displayName: 'ワンポイントマスク',
        printTag: 'オリジナル印刷OK'
      }
    ]
  },
  {
    sectionTitle: 'オリジナルグッズ定番商品',
    productItems: [
      {
        id: 80,
        productImage: 'https://cdn-novelty.raksul.com/public_images/97a94c93-43c1-4df5-9d4c-42d9d4539100',
        minProductPrice: 99,
        maxProductPrice: 3678,
        quantityUnit: '枚',
        minProductQuantity:10,
        maxProductQuantity: 10000,
        displayName: 'コットン フラットオリジナルトートバッグ（A4サイズ）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 1,
        productImage: 'https://cdn-novelty.raksul.com/public_images/a0d1cb86-1883-414c-bf58-5b828242712d',
        minProductPrice: 140,
        maxProductPrice: 283,
        quantityUnit: '枚',
        minProductQuantity:100,
        maxProductQuantity: 1000,
        displayName: 'ジェットストリーム（名入れボールペン）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 38,
        productImage: 'https://cdn-novelty.raksul.com/public_images/d5e356c9-0c2a-4e9c-905b-efc566834bca',
        minProductPrice: 26,
        maxProductPrice: 218,
        quantityUnit: '枚',
        minProductQuantity:100,
        maxProductQuantity: 20000,
        displayName: 'A4オリジナルクリアファイル',
        printTag: 'オリジナル印刷OK'
      },{
        id: 544,
        productImage: 'https://cdn-novelty.raksul.com/public_images/8e27c29f-7567-4801-a283-b4679d5cea90',
        minProductPrice: 41,
        maxProductPrice: 220,
        quantityUnit: '枚',
        minProductQuantity:1000,
        maxProductQuantity: 30000,
        displayName: 'ウェットティッシュスリム除菌10枚',
        printTag: 'オリジナル印刷OK'
      }
    ]
  },
  {
    sectionTitle: '大手メーカー商品',
    productItems: [
      {
        id: 107,
        productImage: 'https://cdn-novelty.raksul.com/public_images/4cdca8c4-da1e-4204-8806-17db67230c10',
        minProductPrice: 3107,
        maxProductPrice: 7700,
        quantityUnit: '枚',
        minProductQuantity:1,
        maxProductQuantity: 800,
        displayName: 'Anker PowerCore 10000（オリジナルモバイルバッテリー）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 545,
        productImage: 'https://cdn-novelty.raksul.com/public_images/542a06a3-9bce-4609-8ac6-c88d6d33845b',
        minProductPrice: 166,
        maxProductPrice: 416,
        quantityUnit: '枚',
        minProductQuantity:60,
        maxProductQuantity: 2000,
        displayName: 'ハイチュウ（グレープ）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 577,
        productImage: 'https://cdn-novelty.raksul.com/public_images/e18fe6f5-c86e-4f0a-a45e-2fa8987134f2',
        minProductPrice: 1257,
        maxProductPrice: 2127,
        quantityUnit: '枚',
        minProductQuantity:10,
        maxProductQuantity: 1000,
        displayName: 'THERMOS真空断熱タンブラーJDI',
        printTag: 'オリジナル印刷OK'
      },{
        id: 684,
        productImage: 'https://cdn-novelty.raksul.com/public_images/70ed08f3-de7a-499e-a313-8498d8609b77',
        minProductPrice: 141,
        maxProductPrice: 187,
        quantityUnit: '枚',
        minProductQuantity:100,
        maxProductQuantity: 10000,
        displayName: 'トップ スーパーNANOX 10g×3袋 (名入れ洗濯用洗剤)',
        printTag: 'オリジナル印刷OK'
      }
    ]
  },
  {
    sectionTitle: '新着商品',
    productItems: [
      {
        id: 825,
        productImage: 'https://cdn-novelty.raksul.com/public_images/4f2c1d70-559e-4b8e-b989-2bdf7b233b21',
        minProductPrice: 1449,
        maxProductPrice: 4033,
        quantityUnit: '枚',
        minProductQuantity: 10,
        maxProductQuantity: 500,
        displayName: '象印ステンレスマグ SM-PD',
        printTag: 'オリジナル印刷OK'
      },{
        id: 526,
        productImage: 'https://cdn-novelty.raksul.com/public_images/6bd6764d-7397-4f5e-b2d8-ffcdca6e310e',
        minProductPrice: 152,
        maxProductPrice: 256,
        quantityUnit: '枚',
        minProductQuantity: 100,
        maxProductQuantity: 3000,
        displayName: 'キャンパスノート セミB5サイズ（カラー表紙/普通横罫・中横罫）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 720,
        productImage: 'https://cdn-novelty.raksul.com/public_images/79e54dd0-6845-4ee1-8189-260ab5870bad',
        minProductPrice: 5179,
        maxProductPrice: 11921,
        quantityUnit: '枚',
        minProductQuantity: 1,
        maxProductQuantity: 1000,
        displayName: 'Anker Soundcore Mini 3（名入れワイヤレススピーカー）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 661,
        productImage: 'https://cdn-novelty.raksul.com/public_images/e6904226-0090-468b-a8a3-9c2311252ef3',
        minProductPrice: 4614,
        maxProductPrice: 5526,
        quantityUnit: '枚',
        minProductQuantity: 20,
        maxProductQuantity: 500,
        displayName: '名入れホルダー消しゴム モノワン',
        printTag: 'オリジナル印刷OK'
      }
    ]
  },
  {
    sectionTitle: 'Pick Up商品',
    productItems: [
      {
        id: 306,
        productImage: 'https://cdn-novelty.raksul.com/public_images/1c4d0e37-9659-49a6-9a00-f9ce2c43e93c',
        minProductPrice: 682,
        maxProductPrice: 2417,
        quantityUnit: '枚',
        minProductQuantity: 1,
        maxProductQuantity: 5000,
        displayName: '全面印刷陶器オリジナルマグカップ',
        printTag: 'オリジナル印刷OK'
      },{
        id: 438,
        productImage: 'https://cdn-novelty.raksul.com/public_images/d8d2bd8c-c0f7-4bab-9579-07442bf22073',
        minProductPrice: 89,
        maxProductPrice: 213,
        quantityUnit: '枚',
        minProductQuantity: 120,
        maxProductQuantity: 30000,
        displayName: 'オリジナルラベルミネラルウォーター 300ml 丸型（シュリンクラベル）',
        printTag: 'オリジナル印刷OK'
      },{
        id: 672,
        productImage: 'https://cdn-novelty.raksul.com/public_images/811e1775-6a7b-4e6f-8944-0912254e3283',
        minProductPrice: 83,
        maxProductPrice: 206,
        quantityUnit: '枚',
        minProductQuantity: 1000,
        maxProductQuantity: 30000,
        displayName: 'キューブ型ボックスティッシュ60組【1,000個～】',
        printTag: 'オリジナル印刷OK'
      },{
        id: 465,
        productImage: 'https://cdn-novelty.raksul.com/public_images/70dbd00d-621e-43ce-b686-5282cdb9f1d5',
        minProductPrice: 2640,
        maxProductPrice: 10494,
        quantityUnit: '枚',
        minProductQuantity: 1,
        maxProductQuantity: 1395,
        displayName: 'エレコム EX-G ワイヤレスBlueLEDオリジナルマウス Mサイズ',
        printTag: 'オリジナル印刷OK'
      }
    ]
  },
  {
    sectionTitle: 'おすすめ商品',
    productItems: [
      {
        id: 358,
        productImage: 'https://cdn-novelty.raksul.com/public_images/f8c7a26b-2acf-4fe1-8aa2-cf7f83a2fa95',
        minProductPrice: 292,
        maxProductPrice: 3637,
        quantityUnit: '枚',
        minProductQuantity: 5,
        maxProductQuantity: 6000,
        displayName: 'オリジナルデカビアグラス',
        printTag: 'オリジナル印刷OK'
      },{
        id: 662,
        productImage: 'https://cdn-novelty.raksul.com/public_images/6d4a8af5-3809-41ff-bc46-33021c05ff10',
        minProductPrice: 172,
        maxProductPrice: 270,
        quantityUnit: '枚',
        minProductQuantity: 100,
        maxProductQuantity: 1000,
        displayName: '名入れテープのり ピットパワーエッグ',
        printTag: 'オリジナル印刷OK'
      },{
        id: 468,
        productImage: 'https://cdn-novelty.raksul.com/public_images/43782343-6e18-47d9-aa95-d3cb6fd6b41d',
        minProductPrice: 880,
        maxProductPrice: 7700,
        quantityUnit: '枚',
        minProductQuantity: 1,
        maxProductQuantity: 1920,
        displayName: 'エレコム オリジナルUSB2.0ハブ コンパクトタイプ',
        printTag: 'オリジナル印刷OK'
      },{
        id: 683,
        productImage: 'https://cdn-novelty.raksul.com/public_images/7cd1f771-bc4d-47e5-9d8f-0dbebe01f002',
        minProductPrice: 100,
        maxProductPrice: 132,
        quantityUnit: '枚',
        minProductQuantity: 160,
        maxProductQuantity: 10080,
        displayName: '冷えピタ大人用 ２枚入 (名入れ冷却ジェルシート)',
        printTag: 'オリジナル印刷OK'
      }
    ]
  }
]
